<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar extrações BDGD:</v-card-title>

      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            hide-details
            label="Procurar"
            single-line
          />
        </v-col>

        <v-col cols="12">
          <v-data-table
            v-model="extracoesSelecionadas"
            :headers="headers"
            :hide-default-footer="loading"
            :hide-default-header="loading"
            :items="extracoes"
            :items-per-page="itemsPerPage"
            :loading="loading"
            :mobile-breakpoint="0"
            :page.sync="currentPage"
            :search.sync="search"
            class="mx-10"
            item-key="id"
            no-data-text="Nenhuma exportação BDGD disponível"
            show-select
          >
            <template v-slot:[`item.titulo`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="text-truncate" style="max-width: 260px" v-bind="attrs" v-on="on">{{ item.titulo }}</div>
                </template>
                <span>{{ item.titulo }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.tabela`]="{ item }">
              {{ item.tabela || '—' }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              {{ item.status || '—' }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-space-between pb-4 px-6">
        <v-btn color="error" text @click="$emit('update:activated', false)">Cancelar</v-btn>
        <v-btn color="primary" @click="confirmarSelecao">Aplicar seleção</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GestaoBdgdsErrosTarefasService from '@/services/GestaoBdgdsErrosTarefasService';

  export default {
    name: 'DialogSeletorExtracaoBdgdTarefas',

    props: {
      activated: {
        type: Boolean,
        required: true
      },
      bdgdId: {
        type: [Number, String],
        required: true
      },
      entidade: {
        type: String,
        default: ''
      },
      selecionados: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Título', value: 'titulo' },
        { text: 'Tabela', value: 'tabela' },
        { text: 'Status', value: 'status' }
      ],
      extracoes: [],
      extracoesSelecionadas: [],
      loading: false
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.carregarExtracoes();
    },

    methods: {
      async carregarExtracoes() {
        this.loading = true;

        try {
          const { data } = await GestaoBdgdsErrosTarefasService.listarExtracoesBdgd(this.bdgdId, this.entidade);
          this.extracoes = Array.isArray(data?.data) ? data.data : [];
          this.sincronizarSelecionados();
        } catch (error) {
          this.$toast.error('Erro ao recuperar as exportações BDGD.', '', { position: 'topRight' });
        } finally {
          this.loading = false;
        }
      },

      confirmarSelecao() {
        this.$emit('selected', [...this.extracoesSelecionadas]);
        this.search = '';
      },

      sincronizarSelecionados() {
        const idsSelecionados = new Set(this.selecionados.map((extracao) => extracao.id));
        this.extracoesSelecionadas = this.extracoes.filter((extracao) => idsSelecionados.has(extracao.id));
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      },
      selecionados: {
        deep: true,
        handler() {
          this.sincronizarSelecionados();
        }
      }
    }
  };
</script>
